import celiaHeadshotSrc from '@images/team/headshot_celia.jpg';
import lynnHeadshotSrc from '@images/team/headshot_lynn.jpg';
import mattHeadshotSrc from '@images/team/headshot_matt_foster.jpg';
import melissaHeadshotSrc from '@images/team/headshot_melissa_fagedorn.jpg';
import rachelHeadshotSrc from '@images/team/headshot_rachel_porges.jpg';
export var teamMembersSectionContent = {
    teamMembers: [
        {
            name: 'Matthew Foster',
            role: 'General Manager',
            biography: 'Matthew is our General Manager and is responsible for co-creating and implementing the vision for Nom Nom. Matthew joins us after six years as General Manager of Royal Canin, Australia and New Zealand. Before this, he spent years in the fast-moving world of consumer goods, which took him to locations around the world. He holds a degree in Economics from the Australian National University. Matthew believes that pets make our world better, and it is our responsibility to make the world better for them.',
            imageData: {
                src: mattHeadshotSrc,
                alt: 'Matthew Foster',
            },
        },
        {
            name: 'Celia Glass',
            role: 'VP, Business & Customer Operations ',
            biography: 'Celia is our VP of Business and Customer Operations, overseeing HR, Customer Service, strategic execution, IT, and communications. Before coming to Nom Nom, Celia spent 4+ years practicing law at Wachtell, Lipton, Rosen & Katz in New York. She holds a BS and a JD from Duke University, and an MBA from Quantic School of Business and Technology. ',
            imageData: {
                src: celiaHeadshotSrc,
                alt: 'Celia Glass',
            },
        },
        {
            name: 'Melissa Hagedorn',
            role: 'Chief Financial Officer',
            biography: 'Melissa is our Chief Financial Officer, leading the finance and accounting team. Melissa is an ex-Mars Associate, having worked in Mars Wrigley (through the integration) and Mars Pet Nutrition. She left Mars to join Amazon and also worked in the healthcare industry. Melissa holds an MBA from Kellogg School of Business and a BS degree in Finance from Miami of Ohio.',
            imageData: {
                src: melissaHeadshotSrc,
                alt: 'Melissa Hagedorn',
            },
        },
        {
            name: 'Lynn Hubbard',
            role: 'VP, Research & Development',
            biography: 'Lynn is our VP of Research & Development, leading the charge to deliver safe, quality meals while reducing cost and enabling growth. Lynn joined Nom Nom after 18 years in manufacturing and R&D with General Mills, as well as managing finances and operations within nonprofits. Lynn has PhDs in Biological & Agricultural Engineering as well as Food Science from NC State University.',
            imageData: {
                src: lynnHeadshotSrc,
                alt: 'Lynn Hubbard',
            },
        },
        {
            name: 'Rachel Porges',
            role: 'Chief Innovation & Brand Development Officer',
            biography: 'Rachel is our Chief Innovation & Brand Development Officer, a role in which she works with a dynamic marketing, sales and innovation team to encourage pet parents to try, buy and experience Nom Nom. She’s spent nearly 20 years in marketing and consumer strategy, formerly as CMO at Levain Bakery, VP of Sales & Marketing at JSX, and Head of Marketing at Kriser’s Natural Pet, as well as Neutrogena and Unilever. She earned an MBA from Wharton and a BS from Boston University. ',
            imageData: {
                src: rachelHeadshotSrc,
                alt: 'Rachel Porges',
            },
        },
    ],
    tickerText: 'our pack leaders',
};
